import { Option } from '../dropDownInput/dropDownInput.type';
import { OptionGroup } from '../multiSelectDropdown/multiSelectDropdown.type';

export enum FilterFieldType {
  SELECT = 'select',
  MULTI_SELECT = 'multiSelect',
  GROUPED_MULTI_SELECT = 'groupedMultiSelect',
  DATE_PICKER = 'datePicker',
  DATE_RANGE = 'dateRange',
  TIME_PICKER = 'timePicker',
  TIME_RANGE = 'timeRange',
  SECTION_HEADER = 'sectionHeader',
}

export type FilterFieldConfig = {
  key: string | [string, string];
  label: string;
  type: FilterFieldType;
  options?: Option[];
  groups?: OptionGroup[];
  search?: boolean;
  placeholder?: string;
  showDivider?: boolean;
};

export type FilterPanelProps = {
  fields: FilterFieldConfig[];
  values: Record<string, unknown>;
  onChange: (key: string, value: unknown) => void;
};
